var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-popup",style:(_vm.setBackground),on:{"click":function($event){return _vm.updateBackground()}}},[(_vm.image)?_c('div',{staticClass:"card-popup--text"},[_vm._v(" "+_vm._s('by ' + _vm.text)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }